import ApiClient from './api-client'

export default (headers, config) => ({
  client: ApiClient(headers, config),

  buildUrl (url) {
    if (url.startsWith('/')) return url
    return `/${url}`
  },

  query (url) {
    return this.client.query(this.buildUrl(url))
  },

  get (url) {
    return this.client.get(this.buildUrl(url))
  },

  post (url, data) {
    return this.client.post(this.buildUrl(url), data)
  },

  getFileDownload (url, downloadProgressFn) {
    let fileDownloadApiClient = ApiClient(
      {},
      {
        timeout: 60000,
        responseType: 'blob',
        onDownloadProgress: downloadProgressFn
      }
    )
    return fileDownloadApiClient.get(this.buildUrl(url))
  },

  postFormData (url, data) {
    let formDataApiClient = ApiClient(
      { 'Content-Type': 'multipart/form-data' },
      (config = { timeout: 60000 })
    )
    return formDataApiClient.post(this.buildUrl(url), data)
  },

  update (url, data) {
    return this.client.update(this.buildUrl(url), data)
  },

  put (url, data) {
    return this.client.put(this.buildUrl(url), data)
  },

  delete (url) {
    return this.client.delete(this.buildUrl(url))
  }
})



// WEBPACK FOOTER //
// ./src/api/api-wrapper.js